import Icon from '../components/Icon.vue'

Icon.register({"procedures":{"width":640,"height":512,"paths":[{"d":"M528 224H272C263.2 224 256 231.2 256 240V384H64V144C64 135.2 56.8 128 48 128H16C7.2 128 0 135.2 0 144V496C0 504.8 7.2 512 16 512H48C56.8 512 64 504.8 64 496V448H576V496C576 504.8 583.2 512 592 512H624C632.8 512 640 504.8 640 496V336C640 274.1 589.9 224 528 224zM136 96H262.1L289.7 151.2C295.6 163 312.4 163 318.3 151.2L368 51.8 390.1 96H512C520.8 96 528 88.8 528 80S520.8 64 512 64H409.9L382.3 8.8C376.4-3 359.6-3 353.7 8.8L304 108.2 284.1 68.4C282.7 65.7 280 64 276.9 64H136C131.6 64 128 67.6 128 72V88C128 92.4 131.6 96 136 96zM160 352C195.3 352 224 323.3 224 288S195.3 224 160 224 96 252.7 96 288 124.7 352 160 352z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/procedures.js
// module id = 94cl
// module chunks = 0